<ng-container *ngIf="displayErrorBanner">
  <div class="error-banner-container">
    <div class="col-1 col-sm-1 col-md-1 col-lg-1">
      <div class="status-icon float-end">
        <i class="fa fa-exclamation-triangle warning-exclamation-icon fa-inverse"></i>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-10 col-lg-10">
      <p class="file-format-text" id="banner-error-msg">{{ showBannerErrorMsg }}</p>
    </div>
    <div class="col-1 col-sm-1 col-md-1 col-lg-1">
      <div class="exit-button float-end" (click)="closeMessageBanner()">
        <img src="assets/images/x_white.svg" />
      </div>
    </div>
  </div>
</ng-container>
<ng-container>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
    <div class="col-12 col-sm-12 col-md-8 col-lg-8">
      <i class="statistics-disclosure-text">{{ preliminaryDisclosureText }}</i>
    </div>
    <div class="col-12 col-sm-12 col-md-8 col-lg-8">
      <p class="statistics-text">
        All Statistics data as of <b>{{ month }}/{{ year }}</b>
      </p>
    </div>
    <div class="col-3 col-sm-3 col-md-3 col-lg-3">
      <div class="row float-end jump-selection">
        <div class="dropdown status-dropdown" id="timeSpan" (mouseleave)="closeJumpToDropdown()">
          <span class="status">Jump to : </span>
          <button
            class="btn btn-secondary dropdown-toggle time-span-dropdown dropdown-text jump-to-button jump-to-set-selection"
            type="button"
            id="dropdownTimeSpan"
            (click)="toggleJumpToDropdown()"
            [attr.aria-expanded]="isJumpToDropdownOpen"
          >
            Select section
            <span class="fa fa-chevron-down mega-dropdown-caret jump-to-caret"></span>
          </button>
          <ul
            class="dropdown-menu dropdown-select-time statistics-table-section"
            [ngClass]="{ show: isJumpToDropdownOpen }"
          >
            <li>
              <a
                href="#goToLoanPurpose"
                (click)="setSelected('LOAN PURPOSE')"
                class="dropdown-item jump-to-selection-dropdown"
                >Loan Purpose</a
              >
            </li>
            <li>
              <a
                href="#goToOccupancyStatus"
                (click)="setSelected('OCCUPANCY STATUS')"
                class="dropdown-item jump-to-selection-dropdown"
                >Occupancy Status</a
              >
            </li>
            <li>
              <a
                href="#goToChannel"
                (click)="setSelected('CHANNEL')"
                class="dropdown-item jump-to-selection-dropdown"
                >Channel</a
              >
            </li>
            <li>
              <a
                href="#goToPropertyState"
                (click)="setSelected('PROPERTY STATE')"
                class="dropdown-item jump-to-selection-dropdown"
                >Property State</a
              >
            </li>
            <li>
              <a
                href="#goToPropertyType"
                (click)="setSelected('PROPERTY TYPE')"
                class="dropdown-item jump-to-selection-dropdown"
                >Property Type</a
              >
            </li>
            <li>
              <a
                href="#goToQuartile"
                (click)="setSelected('QUARTILE')"
                class="dropdown-item jump-to-selection-dropdown"
                >Quartile</a
              >
            </li>
            <li>
              <a
                href="#goToNoOfBorrowers"
                (click)="setSelected('NUMBER OF BORROWERS')"
                class="dropdown-item jump-to-selection-dropdown"
                >Number of Borrowers</a
              >
            </li>
            <li>
              <a
                href="#goToMortgageInsuranceCanInd"
                (click)="setSelected('MORTGAGE INSURANCE CANCELLATION INDICATOR')"
                class="dropdown-item jump-to-selection-dropdown"
                >Mtg. Ins. Cancel. Ind.</a
              >
            </li>
            <li>
              <a
                href="#goToMortgageInsuranceCov"
                (click)="setSelected('MORTGAGE INSURANCE COVERAGE')"
                class="dropdown-item jump-to-selection-dropdown"
                >Mtg. Ins. Coverage</a
              >
            </li>
            <li>
              <a
                href="#goToNoOfUnits"
                (click)="setSelected('NUMBER OF UNITS')"
                class="dropdown-item jump-to-selection-dropdown"
                >Number of Units</a
              >
            </li>
            <li>
              <a
                href="#goToOriginationYear"
                (click)="setSelected('ORIGINATION YEAR')"
                class="dropdown-item jump-to-selection-dropdown"
                >Origination Year</a
              >
            </li>
            <li>
              <a
                href="#goToServicerDistribution"
                (click)="setSelected('SERVICER DISTRIBUTION')"
                class="dropdown-item jump-to-selection-dropdown"
                >Servicer Distribution</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
    <div class="line-break"></div>
  </div>

  <h3 class="analyzer-details-title" name="jumpToLoanPurpose">Loan Purpose</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-statistics-loan-header">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>LOAN PURPOSE</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>
      <ng-container *ngIf="loanPurposeResResolved == undefined">
        <span class="pr-loan" *ngIf="!loanPurposeResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="loanPurposeResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="loanPurposeResResolved !== undefined">
        <tbody
          id="collateral-analyzer-statistics-loan-body"
          *ngFor="let loanPurpose of loanPurposeResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ loanPurpose?.attributeType }}
            </td>
            <td class="td_cell align-right">
              {{ loanPurpose?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ loanPurpose?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ loanPurpose?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ loanPurpose?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
    <button class="button fm-secondary-button scrollTopButton" (click)="scrollToTop()">
      SCROLL TOP
    </button>
  </div>

  <h3 class="analyzer-details-title" id="goToOccupancyStatus">Occupancy Status</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-statistics-occupancy-header">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>OCCUPANCY STATUS</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="occupancyStatusResResolved == undefined">
        <span class="pr-loan" *ngIf="!occupancyStatusResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="occupancyStatusResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="occupancyStatusResResolved !== undefined">
        <tbody
          id="collateral-analyzer-statistics-occupancy-body"
          *ngFor="let occupancyStatus of occupancyStatusResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ occupancyStatus?.attributeType }}
            </td>
            <td class="td_cell align-right">
              {{ occupancyStatus?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ occupancyStatus?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ occupancyStatus?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ occupancyStatus?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToChannel">Channel</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-statistics-channel-header">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>CHANNEL</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="channelResResolved == undefined">
        <span class="pr-loan" *ngIf="!channelResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="channelResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="channelResResolved !== undefined">
        <tbody
          id="collateral-analyzer-statistics-channel-body"
          *ngFor="let channel of channelResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ channel?.attributeType }}
            </td>
            <td class="td_cell align-right">
              {{ channel?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ channel?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ channel?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ channel?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToPropertyState">Property State</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-state">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>STATE</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="stateResResolved == undefined">
        <span class="pr-loan" *ngIf="!stateResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="stateResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="stateResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-state"
          *ngFor="let state of stateResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ state?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ state?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ state?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ state?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ state?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToPropertyType">Property Type</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-s">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>PROPERTY TYPE</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="propertyTypeResResolved == undefined">
        <span class="pr-loan" *ngIf="!propertyTypeResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="propertyTypeResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="propertyTypeResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-b"
          *ngFor="let propertyType of propertyTypeResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ propertyType?.attributeType }}
            </td>
            <td class="td_cell align-right">
              {{ propertyType?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ propertyType?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ propertyType?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ propertyType?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToQuartile">Quartile Distribution</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-quartile">
        <tr class="th_row">
          <th class="th_column quartile-level align-left">
            <span>QUARTILE LEVEL</span>
          </th>
          <th class="th_column quartile-mort-loan-amount align-right">
            <span>MORTGAGE LOAN AMOUNT</span>
          </th>
          <th class="th_column quartile-interest-rate align-right">
            <span>INTEREST RATE</span>
          </th>
          <th class="th_column quartile-net-interest-rate align-right">
            <span>NET INTEREST RATE</span>
          </th>
          <th class="th_column quartile-loan-term align-right">
            <span>LOAN TERM</span>
          </th>
          <th class="th_column quartile-loan-age align-right">
            <span>LOAN AGE</span>
          </th>
          <th class="th_column quartile-loan-to-val align-right">
            <span>LOAN-TO-VALUE (LTV)</span>
          </th>
          <th class="th_column quartile-months-maturity align-right">
            <span>REMAINING MONTHS TO MATURITY</span>
          </th>
          <th class="th_column quartile-cltv align-right">
            <span>COMBINED LOAN-TO-VALUE (CLTV)</span>
          </th>
          <th class="th_column quartile-credit-score align-right">
            <span>BORROWER CREDIT SCORE</span>
          </th>

          <th class="th_column quartile-dti align-right">
            <span>DEBT-TO-INCOME (DTI)</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="quartileRes !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-quartile"
          *ngFor="let quartile of quartileRes; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell align-left">
              {{ quartile?.attribute }}
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['mortgageLoanAmount'] == null">
                <span *ngIf="!mortgageLoanAmountQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="mortgageLoanAmountQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['mortgageLoanAmount'] !== null">
                {{ quartile?.mortgageLoanAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['interestRate'] == null">
                <span *ngIf="!interestRateQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="interestRateQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['interestRate'] !== null">
                {{ quartile?.interestRate }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['netInterestRate_Current'] == null">
                <span *ngIf="!netInterestRateCurrentQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="netInterestRateCurrentQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['netInterestRate_Current'] !== null">
                {{ quartile?.netInterestRate_Current }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['loanTerm'] == null">
                <span *ngIf="!loanTermQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="loanTermQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['loanTerm'] !== null">
                {{ quartile?.loanTerm }}
              </ng-container>
            </td>

            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['loanAge'] == null">
                <span *ngIf="!loanAgeQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="loanAgeQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['loanAge'] !== null">
                {{ quartile?.loanAge }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['loanToValue'] == null">
                <span *ngIf="!loanToValueQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="loanToValueQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['loanToValue'] !== null">
                {{ quartile?.loanToValue }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['remainingMonthsToMaturity'] == null">
                <span *ngIf="!remainingMonthsToMaturityQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="remainingMonthsToMaturityQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['remainingMonthsToMaturity'] !== null">
                {{ quartile?.remainingMonthsToMaturity }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['combined_LoanToValue'] == null">
                <span *ngIf="!combinedLoanToValueQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="combinedLoanToValueQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['combined_LoanToValue'] !== null">
                {{ quartile?.combined_LoanToValue }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              <ng-container *ngIf="quartile['borrowerCreditScore'] == null">
                <span *ngIf="!borrowerCreditScoreQuartileError"
                  ><i
                    class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status-quartile"
                  ></i
                ></span>
                <span *ngIf="borrowerCreditScoreQuartileError">
                  <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i
                ></span>
              </ng-container>
              <ng-container *ngIf="quartile['borrowerCreditScore'] !== null">
                {{ quartile?.borrowerCreditScore }}
              </ng-container>
            </td>
            <td class="td_cell align-right">
              {{ quartile?.DTI }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToNoOfBorrowers">Number of Borrowers</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-pT">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>BORROWERS</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="borrowersResResolved == undefined">
        <span class="pr-loan" *ngIf="!borrowersResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="borrowersResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="borrowersResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-bo"
          *ngFor="let borrower of borrowersResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ borrower?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ borrower?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ borrower?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ borrower?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ borrower?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToMortgageInsuranceCanInd">
    Mortgage Insurance Cancellation Indicator
  </h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-mortgageInsCancelInd">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>MORTGAGE INSURANCE CANCELLATION INDICATOR</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="mortgageInsCancelIndResResolved == undefined">
        <span class="pr-loan" *ngIf="!mortgageInsCancelIndResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="mortgageInsCancelIndResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="mortgageInsCancelIndResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-mortgageInsCancelInd"
          *ngFor="
            let mortgageInsCancelInd of mortgageInsCancelIndResResolved;
            trackBy: trackByIdentity
          "
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ mortgageInsCancelInd?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCancelInd?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCancelInd?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCancelInd?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCancelInd?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToMortgageInsuranceCov">Mortgage Insurance Coverage</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-mortgageInsCoverage">
        <tr class="th_row">
          <th class="th_column loan loan table-label">
            <span>MORTGAGE INSURANCE COVERAGE</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="mortgageInsCoverageResResolved == undefined">
        <span class="pr-loan" *ngIf="!mortgageInsCoverageResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="mortgageInsCoverageResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="mortgageInsCoverageResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-mortgageInsCoverage"
          *ngFor="
            let mortgageInsCoverage of mortgageInsCoverageResResolved;
            trackBy: trackByIdentity
          "
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ mortgageInsCoverage?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCoverage?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCoverage?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCoverage?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ mortgageInsCoverage?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToNoOfUnits">Number of Units</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-nu">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>NUMBER OF UNITS</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="numberOfUnitsResResolved == undefined">
        <span class="pr-loan" *ngIf="!numberOfUnitsResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="numberOfUnitsResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="numberOfUnitsResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-nu"
          *ngFor="let units of numberOfUnitsResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ units?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ units?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ units?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ units?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ units?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToOriginationYear">Origination Year</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-origYear">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>ORIG. YEAR</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="originationYearResResolved == undefined">
        <span class="pr-loan" *ngIf="!originationYearResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="originationYearResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="originationYearResResolved !== undefined">
        <tbody
          id="collateral-analyzer-details-section-body-origYear"
          *ngFor="let origYear of originationYearResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell">
              {{ origYear?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ origYear?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ origYear?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ origYear?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ origYear?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>

  <h3 class="analyzer-details-title" id="goToServicerDistribution">Servicer Distribution</h3>

  <div class="fm-cdx-table">
    <table class="fm-cdx-table__static">
      <thead id="collateral-analyzer-details-section-header-servicer">
        <tr class="th_row">
          <th class="th_column table-label">
            <span>SERVICER NAME</span>
          </th>
          <th class="th_column table-label-agg-loan-upb">
            <span>AGGREGATE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-pct-inv-loan-upb">
            <span>PERCENTAGE INVESTOR LOAN UPB</span>
          </th>
          <th class="th_column table-label-agg-loan-count">
            <span>AGGREGATE LOAN COUNT</span>
          </th>
          <th class="th_column table-label-pct-loan-count">
            <span>PERCENTAGE LOAN COUNT</span>
          </th>
        </tr>
      </thead>

      <ng-container *ngIf="servicersResResolved.length === 0">
        <span class="pr-loan" *ngIf="!servicersResError">
          <i
            class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
          ></i
        ></span>
        <tbody *ngIf="servicersResError">
          <tr class="td_row">
            <td class="td_cell">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
            <td class="td_cell align-right">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
            </td>
          </tr>
        </tbody>
      </ng-container>
      <ng-container *ngIf="servicersResResolved.length > 0">
        <tbody
          id="collateral-analyzer-details-section-body-servicer"
          *ngFor="let servicer of servicersResResolved; trackBy: trackByIdentity"
        >
          <tr class="td_row">
            <td class="td_cell servicer-dist-label-value">
              {{ servicer?.recTypeValue }}
            </td>
            <td class="td_cell align-right">
              {{ servicer?.aggUPB | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
            <td class="td_cell align-right">
              {{ servicer?.pctAggUPB }}
            </td>
            <td class="td_cell align-right">
              {{ servicer?.loanCount }}
            </td>
            <td class="td_cell align-right">
              {{ servicer?.pctLoanCount }}
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
  </div>
</ng-container>
